import axios from '@/settings/axios'
import { apiSettings } from "@/settings/api"

let base = '/event/'

export default {
    create(request, version = apiSettings.event_ver) {
        return axios.post(base + version + '/events', request);
    },
    get(id, version = apiSettings.event_ver) {
        return axios.get(base + version + `/events/${id}`);
    },
    delete(id, version = apiSettings.event_ver) {
        return axios.delete(base + version + `/events/${id}`);
    },
    list(page = 1, version = apiSettings.event_ver) {
        return axios.get(base + version + `/events`, { params: { page: page } });
    },
    edit(request, version = apiSettings.event_ver) {
        return axios.put(base + version + '/events', request);
    },
    postCreate(request, version = apiSettings.event_ver) {
        return axios.post(base + version + '/posts', request);
    },
    postUpdate(request, version = apiSettings.event_ver) {
        return axios.put(base + version + '/posts', request);
    },
    postsLoad(request = { event_id: "", page: 1 }, version = apiSettings.event_ver) {
        return axios.get(base + version + `/events/${request.event_id}/posts`, { params:{ page: request.page }});
    },
    postGet(request = { event_id: "", post_id: '' }, version = apiSettings.event_ver) {
        return axios.get(base + version + `/events/${request.event_id}/posts/${request.post_id}`);
    },
    postDelete(request = { event_id: "", post_id: '' }, version = apiSettings.event_ver) {
        return axios.delete(base + version + `/events/${request.event_id}/posts/${request.post_id}`);
    },
    loadAlbum(event_id = "", version = apiSettings.event_ver) {
        return axios.get(base + version + `/events/${event_id}/files`);
    },
    saveAlbum(request = { event_id: '', files: [] }, version = apiSettings.event_ver) {
        return axios.put(base + version + `/eventfile/bind`, request);
    },
    lifeTime(request = { event_id: '', days:''}, version = apiSettings.event_ver) {
        return axios.put(base + version + `/events/${request.event_id}/lifetime/${request.days}`);
    },
    upload(request = { event_id: '', cnt:''}, version = apiSettings.event_ver) {
        return axios.put(base + version + `/events/${request.event_id}/upload/${request.cnt}`);
    },

}
